import types from '../mutation-types';
import ReportsAPI from '../../api/wgpt/reports';
import { throwErrorMessage } from '../utils/api';

export const state = {
  campaignReport: {},
  uiFlags: {
    isFetchingCampaignReport: false,
  },
};

export const getters = {
  getUIFlags: $state => $state.uiFlags,
  campaignReport: $state => $state.campaignReport || {},
};

export const actions = {
  getCampaign: async ({ commit }, id) => {
    commit(types.SET_WGPT_REPORTS_UI_FLAG, { isFetchingCampaignReport: true });
    try {
      const response = await ReportsAPI.getCampaign(id);
      const data = { ...response.data, id };
      commit(types.SET_WGPT_CAMPAIGN_REPORT, data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_REPORTS_UI_FLAG, {
        isFetchingCampaignReport: false,
      });
    }
    return null;
  },
};

export const mutations = {
  [types.SET_WGPT_REPORTS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_WGPT_CAMPAIGN_REPORT]: ($state, data) => {
    $state.campaignReport = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
